export default "__VITE_ASSET__QQWsV9V3__"